import { headers } from "./config";
import { encrypt, generateHMAC } from "../../Utils/hmac";
import api from "./sessionExpiryAxios"
import { getClinicAccessToken } from "../../Utils/clinicAuth";
import { SERVICE_HOST } from "../BaseUrl/serviceHost";

export const CHAT_BASE_PATH = `${SERVICE_HOST}/webhooks/api/chat`;



export const startChatThread = async (payload) => {
    const hmac = await generateHMAC();
    const _n = encrypt(payload);
    const authToken = getClinicAccessToken();

    if (!authToken) {
        throw new Error("Access token is required");
    }

    const updatedHeaders = {
        ...headers,
        Authorization: `Bearer ${authToken}`,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };

    try {
        const response = await api.post(`${CHAT_BASE_PATH}/start`, { _n }, { headers: updatedHeaders });
        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
        throw response;
    } catch (error) {
        console.error("Error starting chat thread:", error);
        throw error;
    }
};

export const getChatThreads = async (filters = {}) => {
    const hmac = await generateHMAC();
    const authToken = getClinicAccessToken();

    if (!authToken) {
        throw new Error("Access token is required");
    }

    const updatedHeaders = {
        ...headers,
        Authorization: `Bearer ${authToken}`,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };

    try {
        const response = await api.get(`${CHAT_BASE_PATH}/threads`, {
            params: {
                company: filters.company,
                ...(filters.status ? { status: filters.status } : {}),
                page: filters.page || 1,
                limit: filters.limit || 20,
            },
            headers: updatedHeaders,
        });

        if (response.status === 200) {
            return response.data;
        }
        throw response;
    } catch (error) {
        console.error("Error fetching chat threads:", error);
        throw error;
    }
};

/**
 * Fetch all messages for a thread using chatToken
 * @param {string} chatToken
 * @returns {Promise}
 */
export const getChatMessages = async (chatToken) => {
    const hmac = await generateHMAC();
    const authToken = getClinicAccessToken();

    if (!authToken) {
        throw new Error("Access token is required");
    }

    const updatedHeaders = {
        ...headers,
        Authorization: `Bearer ${authToken}`,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };

    try {
        const response = await api.get(`${CHAT_BASE_PATH}/messages/${chatToken}`, {
            headers: updatedHeaders,
        });

        if (response.status === 200) {
            return response.data;
        }
        throw response;
    } catch (error) {
        console.error("Error fetching chat messages:", error);
        throw error;
    }
};


export const sendChatReply = async (payload = {}) => {
    const hmac = await generateHMAC();
    const _n = encrypt({
        chatToken: payload.chatToken,
        message: payload.message,
        sentBy: payload.sentBy,
    });
    const authToken = getClinicAccessToken();

    if (!authToken) {
        throw new Error("Access token is required");
    }

    const updatedHeaders = {
        ...headers,
        Authorization: `Bearer ${authToken}`,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };

    try {
        const response = await api.post(`${CHAT_BASE_PATH}/reply`, { _n }, { headers: updatedHeaders });

        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
        throw response;
    } catch (error) {
        console.error("Error sending chat reply:", error);
        throw error;
    }
};